<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" sm="12" class="pt-0 py-0" v-if="showTitle">
      <span class="headline">Alle Medien</span>
    </v-col>
    <v-col cols="12" xs="12" class="pt-0 py-0 d-flex align-end">
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn @click="reload()" icon color="primary"><v-icon>refresh</v-icon></v-btn>
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          single-line
          hide-details
          @keyup.enter="onSearch"
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12" class="mt-8">
      <v-dialog v-model="dlgDetails" scrollable height="400" style="z-index: 999999999">
        <v-card>
          <v-toolbar dark color="cyan darken-3" dense>
            <v-toolbar-title>Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dlgDetails=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-simple-table dense>
              <thead>
              <tr>
                <th class="text-left">Key</th>
                <th class="text-left">Value</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(value, key) in detailItem" :key="key">
                <td>{{ key }}</td>
                <td>
                  <div v-if="Array.isArray(value)">
                    <div v-for="(v, idx) in value" :key="idx">
                      {{ v }}
                    </div>
                  </div>
                  <div v-else>
                    {{ value }}
                  </div>
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dlgDetails = false">schließen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
          :headers="headers"
          :items="mediaList"
          ref="dataTable"
          v-model="selected"
          fixed-header
          :loading="isLoading"
          :search="search"
          :server-items-length="totalCount"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.itemsPerPage"
          :sort-by.sync="pagination.sortBy"
          :sort-desc.sync="pagination.sortDesc"
          :height="tableHeight"
          hide-details
          item-key="uiUniqueId"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100]
          }"
      >
        <template v-slot:item.localFileName="{ item }">
          <v-row>
            <v-img :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" contain
                   alt="Thumbnail"
                   max-height="80" max-width="320" width="320"></v-img>

            <v-btn @click="download(item)" icon class="mt-6">
              <v-icon color="primary">cloud_download</v-icon>
            </v-btn>
          </v-row>
        </template>
        <template v-slot:item.companyName="{ item }">
          <span v-if="item.companyGuid" @click.stop="open(item)"><v-icon>business</v-icon>{{ item.companyName }}</span>
        </template>
        <template v-slot:item.type="{ item }">
          <span>{{ item.type }}</span><br>
          <span>{{ item.convertStatusMessage }} </span><br>
          <span>{{ item.convertStatus }}</span><br>
          <span class="handpointer" @click="openDetails(item)">{{ item.mime }}<v-icon small color="primary">details</v-icon></span><br>
          <span>{{ item.name }}</span><br>
        </template>

        <template v-slot:item.created="{ item }">
          <span> {{ formatDateTime(item.created) }}</span>
        </template>
        <template v-slot:item.size="{ item }">
          <span> {{ toMB(item.size, 2) }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col>
              <v-btn small @click="download(item)">
                <v-icon>download</v-icon>
              </v-btn>
            </v-col>
            <v-col>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>

    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title class="headline">Aktiv Status setzen</v-card-title>
        <v-card-text>Das setzen des Status betrifft <span class="cntOver">{{ cntItems }}</span> Media Items / Items
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken" @click="dialog = false">abbrechen</v-btn>
          <v-btn color="darken" @click="setStatusNow()">Status jetzt setzen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";
import moment from "moment";

var _ = require('lodash')
export default {
  name: 'TableAllMedien',
  props: {
    companyId: String,
    showTitle: Boolean,
    isCompanyView: Boolean
  },
  components: { DialogDeleteItem},
  methods: {

    resize: function () {
      this.tableHeight = window.innerHeight - 246;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 346;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    openDetails: function (item) {
      if (this.hasMediaInfo(item)) {
        this.detailItem = JSON.parse(item.mediaInfo)
        this.dlgDetails = true
      }
    },
    open: function (item) {
      this.$router.push('/Netzwerke/' + item.companyGuid);
    },
    onSearch: function (event) {
      if (event.key === 'Enter') {
        this.reload();
      }
    },
    download: function (item) {
      const url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + item.localFileName;

      // Erstellt eine XHR-Anfrage, um den Fortschritt zu verfolgen
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';  // Antwort als Blob

      // Fortschritt-Event-Handler
      xhr.onprogress = function (event) {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          Vue.prototype.$eventHub.$emit('OnProgress', percent);  // Fortschritt emitten
        }
      };

      // Lade-Event-Handler (am Ende des Downloads)
      xhr.onload = function () {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const link = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);

          link.href = objectUrl;
          link.download = item.name;  // Name der heruntergeladenen Datei
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(objectUrl);  // Gibt die URL frei

          Vue.prototype.$eventHub.$emit('OnProgress', 100);  // Fortschritt auf 100 setzen
        }
      };

      // Fehler-Event-Handler
      xhr.onerror = function () {
        console.error('Download failed.');
      };

      // Anfrage senden
      xhr.send();
    },

    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Medium',
        id: '' + item.guid,
        name: 'Medium ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      // Vue.prototype.$api.deleteDevice(item.item.guid, this.reload)
    },
    onChangeAll: function () {
      Vue.prototype.storage.saveState('deviceShowAll', this.showAll)
      this.reload()
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Geraete/' + item.guid)
      } else {
        this.$router.push('/Geraete/' + item.guid)
      }

    },
    hasMediaInfo: function (item) {
      if (item.mediaInfo) {
        return true
      }  else {
        return {}
      }
    },
    getMediaInfo: function (item) {
      if (item.mediaInfo) {
        return JSON.parse(item.mediaInfo)
      }  else {
        return {}
      }
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      const pagination = this.$refs.dataTable.pagination;
      this.isLoading = true;
      let params = {
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        sortBy: this.pagination.sortBy,
        sortDesc: this.pagination.sortDesc,
        keyWord: this.search
      };
      if (pagination) {
        params = {
          page: pagination.page,
          itemsPerPage: pagination.itemsPerPage,
          sortBy: pagination.sortBy,
          sortDesc: pagination.sortDesc,
          keyWord: params.search
        };
      }
      Vue.prototype.$api.loadMediaAll(this.onGetData, null, params);
    },
    reFilter: function () {
      let list = []
      for (var ii in this.completeData) {
        let item = this.completeData[ii]
        let found = false
        for (var index in item.tagArray) {
          let tag = item.tagArray[index]
          console.log('list', tag, this.filterTags)
          let fIndex = _.findIndex(this.filterTags, function (o) {
            return o === tag
          })
          if (fIndex > -1) {
            found = true
            break
          }
        }
        if (found) {
          list.push(item)
        }
      }
      this.mediaList = list
    },
    onGetData: function (result) {
      this.isLoading = false
      this.mediaList = result.items
      this.cntAll = result.items.length
      this.totalCount = result.gridParams.count
      this.completeData = _.clone(this.mediaList)
    },
    onGetStatusList: function (data) {
      this.cntItems = data.cntMedia
      this.dialog = true
    },
    onGetStatusSet: function (data) {
      console.log('data', data)
      this.dialog = false
      this.reload()
    },
    setAll: function (item, state) {
      this.currentItem = item
      this.currentState = state
      Vue.prototype.$api.checkMediaStateFromCompany(this.companyId, item, state, this.onGetStatusList)
    },
    setAllSelected: function (arr, state) {
      let that = this
      this.currentState = state
      that.cntChanged = 0
      that.shouldChanged = arr.length
      let fnCheck = function (data) {
        console.log('data', data)
        that.cntChanged += 1
        if (that.cntChanged >= that.shouldChanged) {
          that.dialog = false
          that.reload()
        }
      }
      _.each(arr, function (item) {
        Vue.prototype.$api.setMediaStateFromCompany(that.companyId, item, that.currentState, fnCheck)
      })
    },
    setStatusNow: function () {
      Vue.prototype.$api.setMediaStateFromCompany(this.companyId, this.currentItem, this.currentState, this.onGetStatusSet)
    },
    formatDateTime: function (s) {
      return moment(s).format("DD.MM.YYYY HH:mm");
    },
  },
  data() {
    return {
      dlgDetails: false,
      pagination: {
        page: 1,  // Standard-Startseite
        itemsPerPage: 10,  // Standard-Anzahl der Einträge pro Seite
        sortBy: 'created',  // Standard-Sortierung nach dem Erstellungsdatum
        sortDesc: true  // Standardmäßig absteigend sortieren
      },
      cntAll: 0,
      currentDevice: null,
      search: null,
      showAll: false,
      detailItem: null,
      tableHeight: 100,
      dialog: false,
      hdSizeUsed: 0,
      storageInKbDeletable: 0,
      cntChanged: 0,
      cntItems: 0,
      selected: [],
      totalCount: 100,
      tags: [],
      isLoading: false,
      filterTags: [],
      tableUtils: require('./TableUtils').default,
      headers: [],
      mediaList: []
    }
  },
  watch: {

    'pagination.sortDesc': function () {
      console.log('sortDesc', this.pagination)
      this.reload();
    },
    'pagination.sortBy': function () {
      console.log('sortBy', this.pagination)
      this.reload();
    },
    'pagination.page': function () {
      console.log('page', this.pagination)
      this.reload();  // Seite gewechselt, daher reload aufrufen
    }
  },
  mounted() {
    this.headers = [
      {text: 'Netzwerk Name', align: 'left', value: 'companyName'},
      {text: 'Name', align: 'left', value: 'localFileName'},
      {text: 'Type', align: 'left', value: 'type'},
      {text: 'Dateigröße', value: 'size'},
      {text: 'Erstellt', value: 'created'}
    ]
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  }
}
</script>

<style scoped>

.cntOver {
  font-weight: bolder;
  font-size: 2em;
}

</style>
